import React from 'react';
import PropTypes from 'prop-types';

const RoleplayMessageItem = ({ msg, isNew }) => {
  const animClass = isNew ? 'rp-msg is-new' : 'rp-msg';

  if (msg.type === 'scarlett') {
    return (
      <div className={`${animClass} rp-msg-scarlett`}>
        <div className="rp-msg-label">{msg.label || 'Scarlett'}</div>
        <p className="rp-msg-text">{msg.text}</p>
      </div>
    );
  }

  if (msg.type === 'character') {
    return (
      <div className={`${animClass} rp-msg-character`}>
        <div className="rp-char-header">
          <span className="rp-char-name">{msg.characterName}</span>
          {msg.characterRole && (
            <span className="rp-char-role">{msg.characterRole}</span>
          )}
        </div>
        <p className="rp-msg-text">{msg.text}</p>
      </div>
    );
  }

  if (msg.type === 'client-promoted') {
    return (
      <div className={`${animClass} rp-msg-promoted`}>
        <div className="rp-msg-label">You said</div>
        <p className="rp-msg-text">{msg.text}</p>
        <div className="rp-script-confirm">added to script ✓</div>
      </div>
    );
  }

  if (msg.type === 'client-failed') {
    return (
      <div className={`${animClass} rp-msg-failed`}>
        <div className="rp-msg-label">You said</div>
        <p className="rp-msg-text">{msg.text}</p>
      </div>
    );
  }

  if (msg.type === 'user') {
    return (
      <div className={`${animClass} rp-msg-user`}>
        <div className="rp-msg-label">You</div>
        <p className="rp-msg-text">{msg.text}</p>
      </div>
    );
  }

  return null;
};

RoleplayMessageItem.propTypes = {
  msg: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.oneOf(['scarlett', 'character', 'client-promoted', 'client-failed', 'user']).isRequired,
    text: PropTypes.string.isRequired,
    characterName: PropTypes.string,
    characterRole: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  isNew: PropTypes.bool,
};

export default RoleplayMessageItem;
